// Provider & Hook
export { FirebaseProvider, useFirebase } from './hooks/useFirebase';

// Internal (NOT exported - use via provider and hook)
// - api/firebase-service.ts
